/* tslint:disable */
/* eslint-disable */
/**
 * Dataland acounting service API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/accountingservice/model';
// @ts-ignore
import type { TransactionDtoString } from '../../../../../../org/dataland/datalandfrontend/openApiClient/accountingservice/model';
// @ts-ignore
import type { TransactionPost } from '../../../../../../org/dataland/datalandfrontend/openApiClient/accountingservice/model';
/**
 * CreditsControllerApi - axios parameter creator
 */
export const CreditsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve the current balance of Dataland credits for the specified company.
         * @summary Get the current Dataland credits balance for a company.
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalance: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getBalance', 'companyId', companyId)
            const localVarPath = `/credits/{companyId}/balance`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a (positive or negative) amount of Dataland credits to the balance of a company.
         * @summary Post a credits transaction for a company.
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {TransactionPost} transactionPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTransaction: async (companyId: string, transactionPost: TransactionPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('postTransaction', 'companyId', companyId)
            // verify required parameter 'transactionPost' is not null or undefined
            assertParamExists('postTransaction', 'transactionPost', transactionPost)
            const localVarPath = `/credits/{companyId}/transaction`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CreditsControllerApi - functional programming interface
 */
export const CreditsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CreditsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve the current balance of Dataland credits for the specified company.
         * @summary Get the current Dataland credits balance for a company.
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBalance(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBalance(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditsControllerApi.getBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a (positive or negative) amount of Dataland credits to the balance of a company.
         * @summary Post a credits transaction for a company.
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {TransactionPost} transactionPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTransaction(companyId: string, transactionPost: TransactionPost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionDtoString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTransaction(companyId, transactionPost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditsControllerApi.postTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CreditsControllerApi - factory interface
 */
export const CreditsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CreditsControllerApiFp(configuration)
    return {
        /**
         * Retrieve the current balance of Dataland credits for the specified company.
         * @summary Get the current Dataland credits balance for a company.
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalance(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getBalance(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a (positive or negative) amount of Dataland credits to the balance of a company.
         * @summary Post a credits transaction for a company.
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {TransactionPost} transactionPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTransaction(companyId: string, transactionPost: TransactionPost, options?: RawAxiosRequestConfig): AxiosPromise<TransactionDtoString> {
            return localVarFp.postTransaction(companyId, transactionPost, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CreditsControllerApi - interface
 */
export interface CreditsControllerApiInterface {
    /**
     * Retrieve the current balance of Dataland credits for the specified company.
     * @summary Get the current Dataland credits balance for a company.
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBalance(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<number>;

    /**
     * Add a (positive or negative) amount of Dataland credits to the balance of a company.
     * @summary Post a credits transaction for a company.
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {TransactionPost} transactionPost 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postTransaction(companyId: string, transactionPost: TransactionPost, options?: RawAxiosRequestConfig): AxiosPromise<TransactionDtoString>;

}

/**
 * CreditsControllerApi - object-oriented interface
 */
export class CreditsControllerApi extends BaseAPI implements CreditsControllerApiInterface {
    /**
     * Retrieve the current balance of Dataland credits for the specified company.
     * @summary Get the current Dataland credits balance for a company.
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBalance(companyId: string, options?: RawAxiosRequestConfig) {
        return CreditsControllerApiFp(this.configuration).getBalance(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a (positive or negative) amount of Dataland credits to the balance of a company.
     * @summary Post a credits transaction for a company.
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {TransactionPost} transactionPost 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postTransaction(companyId: string, transactionPost: TransactionPost, options?: RawAxiosRequestConfig) {
        return CreditsControllerApiFp(this.configuration).postTransaction(companyId, transactionPost, options).then((request) => request(this.axios, this.basePath));
    }
}

